<script>
  /**
   * Interactive legend. Shows only the parties present in the active year,
   * ordered by frequency (most common first). Clicking a chip toggles its
   * "muted" state, which Chart.svelte uses to filter the data.
   */
  let { parties, mutedParties, partyColor, partyLongName, onToggle } = $props();
</script>

<div class="legend" role="group" aria-label="Partidos visibles">
  {#each parties as p (p.name)}
    <button
      type="button"
      class="legend-item"
      class:muted={mutedParties.has(p.name)}
      aria-pressed={!mutedParties.has(p.name)}
      title={partyLongName(p.name)}
      data-party={p.name}
      onclick={() => onToggle?.(p.name)}
    >
      <span
        class="legend-swatch"
        style:background={partyColor(p.name, p.code)}
      ></span>
      {p.name}
    </button>
  {/each}
</div>
